import { render } from "./MarketModal.vue?vue&type=template&id=3bafae92"
import script from "./MarketModal.vue?vue&type=script&lang=js"
export * from "./MarketModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__